export default "__VITE_ASSET__ce89e1cb__"